import React, { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import { styled } from "@mui/material/styles";
import TablePagination from "@mui/material/TablePagination";
import { formatTimestamp, getRevenueDetails } from "./helper/revenueFormHelper";
import { Loader } from "@egovernments/digit-ui-react-components";

const useStyles = makeStyles({
  table: {
    minWidth: 800,
  },
  tableRow: {
    backgroundColor: "#1F4A7C",
    color: "#fff",
  },
  tableCell: {
    backgroundColor: "#f2f2f2",
    padding: "10px",
    fontWeight: "bold",
    border: "1px solid #ddd",
  },
  blueText: {
    color: "#1F4A7C",
  },
});

const headerData = [{ slno: "Sr. No" }, { applicationNumber: "Application Number" }, { amount: "Amount" }, { payDate: "Pay Date" }];
const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "#1f4a7c",
    color: theme.palette.common.white,
    fontSize: 16,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));
const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
  ":hover": {
    backgroundColor: "#1f4a7c1c",
  },
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));

const PerRevenueDetail = ({ tenantId, selectedFeeType, location }) => {
  const userInfo = Digit.UserService.getUser();
  const authToken = Digit.UserService.getUser()?.access_token || null;
  const classes = useStyles();
  const [isLoading, setIsLoading] = useState(true);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [rowData, setRowData] = useState([]);
  const [page, setPage] = React.useState(0);

  useEffect(() => {
    if (selectedFeeType && tenantId) {
      fetchData(tenantId, selectedFeeType);
    }
  }, [tenantId, selectedFeeType]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const fetchData = async (tenantId, selectedFeeType) => {
    try {
      const result = await getRevenueDetails(authToken, userInfo?.info, tenantId, setIsLoading, { selectedFeeType }, location);

      if (!result) {
        throw new Error("No data received from server");
      } else if (result?.length === 0) {
        console.log("No data found");
      }
      setRowData(result);
    } catch (err) {
      console.error("Error fetching data:", err);
      // handle API error message if available
      const message = err?.response?.data?.message || err?.message || "Something went wrong while fetching data";
      console.log(message);
      setRowData([]);
    }
  };

  return (
    <React.Fragment>
      {isLoading ? (
        <Loader />
      ) : (
        <Paper sx={{ overflow: "hidden", marginY: 2 }}>
          <TableContainer>
            <Table className={classes.table} aria-label="simple table">
              <TableHead>
                <TableRow className={classes.tableRow}>
                  {headerData.map((item) => (
                    <TableCell key={Object.values(item)[0]}>{Object.values(item)[0]}</TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody style={{ backgroundColor: "#fbfaff" }}>
                {rowData &&
                  rowData?.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row, index) => (
                    <StyledTableRow key={row.serialNo}>
                      <StyledTableCell>{index + 1 + page * rowsPerPage}</StyledTableCell>
                      <StyledTableCell>{row?.applicationNumber || "N/A"}</StyledTableCell>
                      <StyledTableCell>{row?.totalAmount || row?.amount || "0"}</StyledTableCell>
                      <StyledTableCell>{formatTimestamp(row?.auditDetails?.lastModifiedTime) || "N/A"}</StyledTableCell>
                    </StyledTableRow>
                  ))}
              </TableBody>
            </Table>
          </TableContainer>
          <TablePagination
            rowsPerPageOptions={[10, 25, 50, 75, 100]}
            component="div"
            count={rowData?.length || 0}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </Paper>
      )}
    </React.Fragment>
  );
};
export default PerRevenueDetail;
